import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Checkbox from '@material-ui/core/Checkbox';

const useTableHeadStyles = makeStyles(theme => ({
    tableCell: {
        whiteSpace: "nowrap",
        padding: "4px 10px 4px 10px"
    },
    noPrint: {
        '@media print' : {
            display: 'none'
        }
    }
}));

export default function PaginatedTableHead(props) {

    const classes = useTableHeadStyles();

    const {
        onSelectAll,
        isSelectAllChecked,
        order,
        orderBy,
        columns,
        viewableColumns,
        onRequestSort
    } = props;

    const filteredColumns = useMemo(() => {
        return columns.filter(column => viewableColumns.indexOf(column.id) > -1);
    }, [columns, viewableColumns]);

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox" className={classes.noPrint}>
                    <Checkbox
                        checked={isSelectAllChecked}
                        onChange={onSelectAll}
                        color="primary"
                        />
                </TableCell>
                {filteredColumns.map(column => (
                    <TableCell
                        key={column.id}
                        align={column.align}
                        padding={column.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === column.id ? order : false}
                        classes={{
                            root: classes.tableCell,
                            head: classes.tableCell
                        }}
                        >
                        <Tooltip
                            title={(orderBy === column.id) ? (order === 'asc' ? 'Ascending' : 'Descending') : 'Sort by ' + column.label}
                            placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                            enterDelay={300}
                            >
                            <TableSortLabel
                                active={orderBy === column.id}
                                direction={order}
                                onClick={(e) => onRequestSort(e, column.id)}
                                hideSortIcon
                                >
                                {column.label}
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}
